import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const ViewVersionContentModal = ({ htmlContent }) => {
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <span
        onClick={openModal}
        className="c-pointer">
        <i className="fa-solid fa-eye text-info me-3"></i>
      </span>

      <Modal show={showModal} onHide={closeModal} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>View Document Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewVersionContentModal;
